import {
  _sharedActionsConstantsParagraphs,
  _sharedActionsParagraphs
} from "@/shared/store/paragraphs/actions";

export const paragraphsReducerConstants = {
  ..._sharedActionsConstantsParagraphs,
  FETCH_CHAPTER_PARAS: "paras/FETCH_CHAPTER_PARAS",
};

export const paragraphsReducerActions = {
  ..._sharedActionsParagraphs,
  fetchParas: (chapterId, highlight, onResponseNotIncludesRequestedChapterId) => ({
    type: paragraphsReducerConstants.FETCH_CHAPTER_PARAS,
    data: { chapterId, highlight, onResponseNotIncludesRequestedChapterId }
  }),
};
